"use client";

import { Dialog } from "@boostdev/design-system-components/client";
import { type ReactNode } from "react";
import css from "./PhotoModal.module.css";

export interface PhotoModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly children: ReactNode;
  /** Accessible name for the dialog — required for screen readers. */
  readonly ariaLabel: string;
}

/**
 * Thin wrapper over the DS Dialog primitive. The DS Dialog is built on the
 * native <dialog> element, so Esc-to-close and backdrop-click-to-close come
 * for free, as does focus management. Body content (image + prev/next +
 * download/share) lives in PhotoModalViewer.
 */
export function PhotoModal({
  isOpen,
  onClose,
  children,
  ariaLabel,
}: PhotoModalProps) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      aria-label={ariaLabel}
      className={css.dialog}
    >
      <div className={css.body}>{children}</div>
    </Dialog>
  );
}
